import logo from '../images/t.png';
import React from 'react';
import './css/Headshot.css';

function Logo(){
  return (
    <div className='container'>
      <div className='row center head-row'>
    <img src = {logo} alt="Logo"></img>
    </div>
    </div>
  );
}

export default Logo;